<div class="article">
  <div class="article__close" *ngIf="breakpoints.large || breakpoints.extraLarge " (click)="closeArticle()"><span
      class="icon icon_cross-light"></span></div>
  <div class="article__wrapper">
    <div class="article__page_header" *ngIf="breakpoints.small || breakpoints.extraSmall">
      Credit Tools
    </div>
    <div class="article__header">
      <div class="article__close" *ngIf="breakpoints.small || breakpoints.extraSmall" (click)="closeArticle()"><span
          class="icon icon_cross-light"></span></div>
      <div class="article__category">
        <div class="category-name">{{content?.category}}</div>
        <div class="article-date">{{content?.publishDate | date:'longDate'}}</div>
      </div>
      <!-- <div class="article__image" *ngIf="!content?.headerVideo?.id">
        <img [src]="content?.headerImage?.url')" alt="" loading="lazy">
      </div> -->
      <div class="article__image" *ngIf="!breakpoints.extraSmall && !content?.headerVideo?.id" >
        <img [src]="content?.headerImage?.url" alt="" loading="lazy">
        <span *ngIf="content?.type === 'Article'" class="articleTypeIcon icon icon_article-icon"></span>
        <span *ngIf="content?.type === 'Video'"   class="articleTypeIcon icon icon_video-icon"></span>
      </div>
      <div class="article__image" *ngIf="breakpoints.extraSmall && !content?.headerVideo?.id">
        <img [src]="content?.headerImage?.url" alt="" loading="lazy">
        <span *ngIf="content?.type === 'Article'" class="articleTypeIcon icon icon_article-icon-black"></span>
        <span *ngIf="content?.type === 'Video'"   class="articleTypeIcon icon icon_video-icon-black"></span>
      </div>
      <!-- <div class="article__image" *ngIf="content?.headerVideo?.id && !showVideoModal">
            <div class="videoPlayer__wrapper">Click on the image to play video
            </div>
              <img [src]="content?.headerImage?.url')" alt="" loading="lazy" (click)="videoOnClick()">
          </div> -->
      <div class="videoModal" *ngIf="content?.headerVideo?.id" id="videoModal">
        <div class="videoModal__wrapper">
          <!-- <div class="close" (click)="closeVideoModal()"><span class="icon icon_cross-light"></span></div> -->
          <app-video-player [isArticle]="true" [poster]="content?.headerImage?.url" [content]="content?.headerVideo"
            [modalVideo]="true"></app-video-player>
        </div>
      </div>
      <div class="article__title">
        <div class="titleTextDiv title-text">{{content?.title}}</div>
        <div *ngIf="breakpoints.extraSmall" class="export"><span (click)='shareLink()' class="icon icon_open-blue"></span></div>
      </div>
      <div class="article__author">
        <div class="author__info">
          <div class="author-avatar">
            <img [src]="author?.imageUrl" alt="" loading="lazy">
          </div>
          <div class="author-name">
            {{"by "+ author?.firstName + " " + author?.lastName}}
          </div>
        </div>
        <div class="ratingBlock author-rating">
          <span class="authorRatingNumbers">(02)</span>
          <span class="starsBlockA">
            <span *ngFor="let item of items; let i = index">
              <span *ngIf="i < markedStars" class="starBlue icon icon_star-blue"></span>
              <span *ngIf="i >= markedStars" class="starWhite icon icon_star-white"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="article__content" [innerHTML]="content?.body | sanitizeHtml"></div>
    <!-- <div class="article__content" [innerHTML]="content?.body"></div> -->
    <div class="article__author_about">
      <h1>Author Bio</h1>
      <p>{{author?.biography}}</p>
    </div>
    <div *ngIf="!breakpoints.extraSmall" class="article__disclaimer">
      This material has been prepared for informational purposes only and is not intended to provide, and should not be
      relied on for, financial advice.
    </div>
    <div  class="articleReviewBlock">
      <span class="reviewText">Write your review</span>
      <span class="starsBlockB">
        <span *ngFor="let item of items; let i = index">
          <span *ngIf="i < markedStarsArticle" class="starBlue icon icon_star-blue"></span>
          <span *ngIf="i >= markedStarsArticle" class="starWhite icon icon_star-white"></span>
        </span>
      </span>
      <span class="reviewRatingNumbers">(150)</span>
    </div>

    <div class="article__navigation">
      <div class="navigation navigation__previous" (click)="articlesNavigate(articleIndex - 1)"><span
          class="icon icon_chevron-prev "></span>Previous </div>
      <div class="navigation navigation__next" (click)="articlesNavigate(articleIndex + 1)">Next<span
          class="icon icon_chevron-next "></span></div>
    </div>

    <div class="article__related" *ngIf="content?.related?.length !== 0">
      <div class="relatedHead related__head">
        Related content
      </div>
      <div class="related__items">
        <div class="related__item" *ngFor="let item of content?.related">
          <div *ngIf="!breakpoints.extraSmall" class="related__item_image">
            <img [src]="getRelatedImage(item.contents)" alt="" loading="lazy">
            <span *ngIf="item.type === 'Article'" class="relatedItemIcon icon icon_article-icon"></span>
            <span *ngIf="item.type === 'Video'"   class="relatedItemIcon icon icon_video-icon"></span>
          </div>
          <div *ngIf="breakpoints.extraSmall" class="related__item_image">
            <img [src]="getRelatedImage(item.contents)" alt="" loading="lazy">
            <span *ngIf="item.type === 'Article'" class="relatedItemIcon icon icon_article-icon-black"></span>
            <span *ngIf="item.type === 'Video'"   class="relatedItemIcon icon icon_video-icon-black"></span>
          </div>
          <div class="related__item_title">{{item?.title}}</div>
          <div class="relatedDescription related__item_description">{{item?.excerpt}}</div>
          <a class="related__item_more" (click)="articlesTo(getRelatedTitle(item?.title))">Learn more</a>
        </div>
      </div>
    </div>
  </div>
</div>
